import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Associado } from '@/types/database'

interface PortalStore {
    associado: Associado | null
    cpf: string | null
    isAuthenticated: boolean
    setAssociado: (associado: Associado | null, cpf?: string) => void
    logout: () => void
}

export const usePortalStore = create<PortalStore>()(
    persist(
        (set) => ({
            associado: null,
            cpf: null,
            isAuthenticated: false,
            setAssociado: (associado, cpf) => set({ 
                associado,
                cpf: cpf || null,
                isAuthenticated: !!associado 
            }),
            logout: () => set({ 
                associado: null,
                cpf: null,
                isAuthenticated: false
            }),
        }),
        { name: '@portal-session' }
    )
)
